import { version } from "../../../../package.json";
/**
 * @internal
 * Private implementation for getting SDK version.
 *
 * @remarks
 * Returns the current SDK version from package.json.
 * Upstream: none (local metadata only).
 *
 * @param _logger - Logger instance for debugging
 * @returns The current SDK version string
 *
 * @example
 * ```typescript
 * const version = _getVersion(logger);
 * console.log(`SDK Version: ${version}`);
 * ```
 */
export function _getVersion() {
    return version;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0YWRhdGEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbWFpbi9tb2R1bGVzL21ldGFkYXRhL21ldGFkYXRhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSwwQkFBMEIsQ0FBQztBQUVuRDs7Ozs7Ozs7Ozs7Ozs7OztHQWdCRztBQUNILE1BQU0sVUFBVSxXQUFXO0lBQ3pCLE9BQU8sT0FBTyxDQUFDO0FBQ2pCLENBQUMifQ==